/**
 * @file BillingSectionTabs.tsx
 * @brief Hairline grid tab row for Billing & Pricing (one section at a time).
 *
 * @author DES
 * @date 30-07-2026
 * @updated 30-07-2026 — keep GridCells; polish active/hover look
 */

import {
  BILLING_SECTION_NAV,
  BILLING_TAB_ICONS,
  type BillingTabId,
  billingTabHref,
} from "../billingNav";
import { SectionTabRow, type SectionTabItem } from "./SectionTabRow";

const TABS: SectionTabItem[] = [
  { id: "overview", label: "Overview" },
  ...BILLING_SECTION_NAV.map((section) => ({
    id: section.id as BillingTabId,
    label: section.label,
  })),
].map((tab) => ({
  ...tab,
  icon: BILLING_TAB_ICONS[tab.id as BillingTabId],
  href: billingTabHref(tab.id as BillingTabId),
  end: tab.id === "overview",
}));

interface BillingSectionTabsProps {
  activeTab: BillingTabId;
}

export function BillingSectionTabs({ activeTab }: BillingSectionTabsProps) {
  return <SectionTabRow tabs={TABS} activeId={activeTab} ariaLabel="Billing sections" />;
}
